import styled from 'styled-components';
import { above, below } from '../../utils/Breakpoints';
import Fondo1 from '../../assets/images/fondo.jpg';
import Fondo2 from '../../assets/images/orto1.jpg';

const fondos = [Fondo1, Fondo2];

export const HeroContainer = styled.div`
	padding-top: 100px;
	height: 600px;
	position: relative;
	box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.15);
	${below.med`
	 	padding-top:50px; 
	  `}
	&:before {
		content: '';
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		position: absolute;
		background-image: url(${fondos[Math.round(Math.random())]});
		background-size: cover;
		background-position: 0px 15%;
		background-repeat: no-repeat;
		filter: blur(3px) brightness(80%);
		${below.med`
      background-position: 30% -25%;
      `}
	}
`;

export const HeroInternalContainer = styled.div`
	margin: 0px 100px;
	height: 100%;
	display: flex;
	${below.med`
  margin:0px 20px;`}
`;

export const HeroImage = styled.img`
	max-height: 90%;
	width: 100%;
	transform: rotate(15deg);
	z-index: -10;

	${below.small`
	  position:absolute;
    left:-10%;
    top:15%;
    z-index:-999;
    width:100%;
    filter:opacity(0.4)
    `}
`;

export const HeroDescription = styled.div`
	width: 100%;
	height: 100%;
	text-align: center;
	color: white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	z-index: 998;
	${below.med`
	  width:100%;`}
`;

export const MainText = styled.h1`
	font-size: 1.5rem;
	font-weight: 500;
	margin: 0;
	line-height: 1.2;
	margin-bottom: 20px;
	& > span {
		font-weight: 900;
		font-size: 2rem;
	}
`;

export const SmallText = styled.p`
	width: 95%;
	font-size: 1.2rem;
	margin: 10px 0px 30px 0px;
`;
